import { type FC, type ReactNode } from "react";

export const Panel: FC<{
  children: ReactNode;
}> = ({ children }) => (
  <div className="divide-y divide-slate-200 overflow-hidden rounded-md border border-slate-200">
    {children}
  </div>
);
